/****************************************************
 * Module Name:  addDepartment.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import Constants from "../../utility/constants";
import Select from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField, Tooltip, FormHelperText } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import DepartmentProxy from "../../utility/proxy/manager/manufacturingProxy/departmentProxy";
import DepartmentGroupProxy from "../../utility/proxy/manager/manufacturingProxy/departmentGroupProxy";
import { LoadingButton } from "@mui/lab";
import UserProxy from "../../utility/proxy/manager/userProxy";
import logo from '../../images/pansuriya.jpg'
import SaveIcon from '@mui/icons-material/Save';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import UserDetailModal from "../operations/userDetailModal";

const fullOptionToValue = (selectedData) => {
  if (selectedData.value) return [selectedData.value];
  let newArr = [];
  selectedData.map((option) => {
    newArr.push(option.value);
    return true;
  });
  return newArr.includes("*") ? [] : newArr;
};

const setPropSourceData = (dataToMap) => {
  let newArr = [];
  dataToMap.map((item) => {
    let option = { value: item.userid, label: item.username };
    newArr.push(option);
    return true;
  });
  return newArr;
};

export default class AddDepartment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newdepartment: this.props.editOperation
        ? this.props.sourceData.departmentName
        : "",
      newdescription: this.props.editOperation
        ? this.props.sourceData.departmentDescription
        : "",
      newDepartmentGroup: this.props.editOperation
        ? {
          value: this.props.sourceData.departmentGroupId,
          label: this.props.sourceData.departmentGroupName,
        }
        : "",
      newmaxdayspacketallowed: this.props.editOperation
        ? this.props.sourceData.maxdayspacketallowed
        : "",
      departmentGroupOptions: [],
      departmentMaxDaysPacketAllowed: [],
      newDepartmentHead: this.props.editOperation
        ? setPropSourceData(this.props.sourceData.heads)
        : "",
      departmentHeadOptions: [],
      newDepartmentUsers: this.props.editOperation
        ? setPropSourceData(this.props.sourceData.users)
        : "",
      departmentUsersOptions: [],
      showError: false,

      validateDepartmentPresentSpinner: false,
      validateDepartmentMaxDaysMsg: "",
      showValidationMessage: false,
      departmentAvailable: true,
      showDepartmentGroupLoadSpinner: true,
      showDepartmentHeadLoadSpinner: true,
      showDepartmentUsersLoadSpinner: true,

      departmentValidationError: "",
      showUserDetailModal: false,
      userDetailContext: "",
    };
    this.getAllDepartmentGroup(false);
    this.getAllDepartmentHead(false);
    this.getAllDepartmentUsers(false);
  }

  getAllDepartmentGroup = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showDepartmentGroupLoadSpinner: true });
    DepartmentGroupProxy.GetAllDepartmentGroup((response) =>
      this.setAllDepartmentGroupData(response)
    );
  };

  setAllDepartmentGroupData = (response) => {
    let optionsArray = [];
    let maxDaysPacketAllowedArray = {};
    response.map((data) => {
      let option = { value: data.id, label: data.name };
      optionsArray.push(option);
      maxDaysPacketAllowedArray[data.id] = data.maxdayspacketallowed;
      return true;
    });

    this.setState({
      departmentGroupOptions: optionsArray,
      departmentMaxDaysPacketAllowed: maxDaysPacketAllowedArray,
      newDepartmentGroup:
        this.state.newDepartmentGroup === "" && optionsArray.length > 0
          ? optionsArray[0]
          : this.state.newDepartmentGroup,
      newmaxdayspacketallowed:
        (this.state.newmaxdayspacketallowed === null || this.state.newmaxdayspacketallowed === "") && optionsArray.length > 0
          ? maxDaysPacketAllowedArray[optionsArray[0].value] || ""
          : this.state.newmaxdayspacketallowed,
      showDepartmentGroupLoadSpinner: false,
    });
  };

  getAllDepartmentHead = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showDepartmentHeadLoadSpinner: true });
    UserProxy.UsersThatAreNotDeptHeads((response) =>
      this.setAllDepartmentHeadData(response)
    );
  };

  setAllDepartmentHeadData = (response) => {
    let optionsArray = [];

    // this is added because if user removes the existing head then it cant select it again as we fetch only those users that are not head from the api
    if (Object.keys(this.props.sourceData).length > 0) {
      this.props.sourceData.heads.map((data) => {
        let option = {
          value: data.userid,
          label: data.userid + " | " + data.username,
        };
        optionsArray.push(option);
        return true;
      });
    }
    response.map((data) => {
      let option = {
        value: data.id,
        label: data.id + " | " + data.username,
      };
      optionsArray.push(option);
      return true;
    });

    this.setState({
      departmentHeadOptions: optionsArray,
      newDepartmentHead:
        this.state.newDepartmentHead === "" && optionsArray.length > 0
          ? [optionsArray[0]]
          : this.state.newDepartmentHead,
      newDepartmentUsers:
        this.state.newDepartmentUsers === "" && optionsArray.length > 0
          ? [optionsArray[0]]
          : this.state.newDepartmentUsers,
      showDepartmentHeadLoadSpinner: false,
    });
  };

  getAllDepartmentUsers = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showDepartmentUsersLoadSpinner: true });
    UserProxy.GetAllEmployeeMini("", (response) =>
      this.setAllDepartmentUsersData(response)
    );
  };

  setAllDepartmentUsersData = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = {
        value: data.id,
        label: data.id + " | " + data.username,
      };
      optionsArray.push(option);

      return true;
    });
    this.setState({
      departmentUsersOptions: optionsArray,
      showDepartmentUsersLoadSpinner: false,
    });
  };

  handleSave = () => {
    let data = {
      departmentId:
        this.props.sourceData === undefined
          ? this.props.departmentId
          : this.props.editOperation
            ? this.props.sourceData.departmentId
            : undefined,
      departmentName: this.state.newdepartment,
      departmentDescription: this.state.newdescription,
      departmentGroupMaxAllowedDays: this.state.newmaxdayspacketallowed,
      departmentGroupId: this.state.newDepartmentGroup.value,
      heads: fullOptionToValue(this.state.newDepartmentHead),
      users: fullOptionToValue(this.state.newDepartmentUsers),
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateDepartmentPresent = (departmentEntered) => {
    if (!departmentEntered || departmentEntered.trim() === "") return;

    this.setState({
      validateDepartmentPresentSpinner: true,
    });

    DepartmentProxy.CheckDepartmentAvailable(departmentEntered, (response) => {
      //if we got response that means department is present at backend
      if (response) {
        //DepartmentName already present
        this.setState({
          validateDepartmentPresentSpinner: false,
          showValidationMessage: true,
          departmentAvailable: false,
        });
      } else {
        //DepartmentName not available, so can be used
        this.setState({
          validateDepartmentPresentSpinner: false,
          showValidationMessage: true,
          departmentAvailable: true,
        });
      }
    });
  };

  buttonDisable = () => {
    if (!this.props.editOperation) {
      return (
        !this.state.showValidationMessage ||
        !this.state.departmentAvailable ||
        this.state.newDepartmentHead.length === 0 ||
        this.state.newDepartmentUsers.length === 0 ||
        this.state.newmaxdayspacketallowed === "" ||
        this.state.validateDepartmentMaxDaysMsg !== ""
      );
    } else {
      return (
        this.state.newDepartmentHead.length === 0 ||
        this.state.newDepartmentUsers.length === 0 ||
        this.state.newmaxdayspacketallowed === "" ||
        this.state.validateDepartmentMaxDaysMsg !== ""
      );
    }
  };

  handleDepartmentHead = (selectedOption) => {
    let combinedArr = [...selectedOption, ...this.state.newDepartmentUsers];
    let newArr = [
      ...new Map(combinedArr.map((v) => [JSON.stringify(v), v])).values(),
    ];
    this.setState({
      newDepartmentHead: selectedOption,
      newDepartmentUsers: newArr,
    });
  };

  handleDepartmentUsers = (selectedOption) => {
    let sameArr = [];

    this.state.newDepartmentHead.map((b) => {
      let indexFound = selectedOption.findIndex((a) => {
        if (a.value === b.value) {
          sameArr.push(b);
        }
        return a.value === b.value;
      });
      return indexFound === -1;
    });

    let combinedArr = [...selectedOption, ...sameArr];
    let newArr = [
      ...new Map(combinedArr.map((v) => [JSON.stringify(v), v])).values(),
    ];
    this.setState({
      newDepartmentUsers: newArr,
      newDepartmentHead: sameArr,
    });
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add department validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />
        {this.state.showUserDetailModal && (
          <UserDetailModal
            show={true}
            handleClose={() => this.setState({ showUserDetailModal: false })}
            handleSelect={(selectedOption) => {
              const selectedData = (this.state.userDetailContext === "H"
                ? this.state.departmentHeadOptions
                : this.state.departmentUsersOptions
              ).filter(opt => selectedOption.includes(opt.value));

              if (this.state.userDetailContext === "H") {
                this.handleDepartmentHead(selectedData);
              } else if (this.state.userDetailContext === "U") {
                this.handleDepartmentUsers(selectedData)
              }
              this.setState({
                userDetailContext: "",
                showUserDetailModal: false
              });
            }}
            userids={(this.state.userDetailContext === "H"
              ? this.state.departmentHeadOptions.map(opt => opt.value)
              : this.state.departmentUsersOptions.map(opt => opt.value)
            )}
            selectedIds={
              this.state.userDetailContext === "H"
                ? this.state.newDepartmentHead.length > 0 ? this.state.newDepartmentHead.map(i => i.value) : []
                : this.state.newDepartmentUsers.length > 0 ? this.state.newDepartmentUsers.map(i => i.value) : []
            }
            usertype={"U"}
            loading={this.state.showUserDetailModal}
            isMulti={true}
          />
        )}

        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false} dialogClassName="custom-modalSize">
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation || this.props.sourceData === undefined
                ? "Edit Department"
                : "Add New Department"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <table>
                <tbody>
                  {this.props.editOperation && (
                    <tr>
                      <td>
                        <Form.Label>Department Id</Form.Label>
                      </td>
                      <td>
                        <Form.Label>
                          {this.props.sourceData.departmentId}
                        </Form.Label>
                      </td>
                    </tr>
                  )}
                  {!this.props.sourceData && (
                    <tr>
                      <td>
                        <Form.Label>Department Id</Form.Label>
                      </td>
                      <td>
                        <Form.Label>{this.props.departmentId}</Form.Label>
                      </td>
                    </tr>
                  )}
                  {(this.props.editOperation || !this.props.sourceData) && (
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  )}
                  <tr>
                    <td style={{ width: "50%" }}>
                      <Form.Label>
                        Department
                        <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    {this.props.editOperation || !this.props.sourceData ? (
                      <td>
                        <Form.Label>{this.state.newdepartment}</Form.Label>
                      </td>
                    ) : (
                      <td>
                        <TextField
                          margin="normal"
                          fullWidth
                          size="small"
                          label="Department (required)"
                          placeholder="Enter Department"
                          value={this.state.newdepartment}
                          autoFocus
                          onBlur={(e) =>
                            this.validateDepartmentPresent(
                              this.state.newdepartment
                            )
                          }
                          onChange={(e) =>
                            this.setState({
                              newdepartment: e.target.value,
                              showValidationMessage: false,
                              departmentValidationError: Utility.CheckIsPresent(
                                e.target.value
                              )
                                ? ""
                                : "Department Cannot be Empty",
                            })
                          }
                          helperText={this.state.departmentValidationError}
                          error={
                            this.state.departmentValidationError.length > 0
                          }
                        />
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      {this.state.validateDepartmentPresentSpinner ? (
                        <CircularProgress size="1rem" />
                      ) : !this.state.showValidationMessage ? (
                        <Box>&nbsp;</Box>
                      ) : this.state.departmentAvailable ? (
                        <font color="green">Department available</font>
                      ) : (
                        <font color="red">Department not available</font>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Description</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Description"
                        placeholder="Enter Description"
                        value={this.state.newdescription}
                        onChange={(e) =>
                          this.setState({
                            newdescription: e.target.value,
                          })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Department Group</Form.Label>
                    </td>
                    <td style={{ width: "100%" }}>
                      <Select menuPlacement="auto"
                        blurInputOnSelect={false}
                        className="basic-single"
                        classNamePrefix="select"
                        value={this.state.newDepartmentGroup}
                        isSearchable={true}
                        name="Department"
                        styles={Constants.Styles}
                        menuPortalTarget={document.body}
                        options={this.state.departmentGroupOptions}
                        onChange={(selectedOption) => {
                          this.setState({
                            newDepartmentGroup: selectedOption,
                            newmaxdayspacketallowed: !this.props.editOperation ? this.state.departmentMaxDaysPacketAllowed[selectedOption.value] || "" : this.state.newmaxdayspacketallowed,
                          })
                        }}
                      />
                    </td>
                    <td>
                      {this.state.showDepartmentGroupLoadSpinner ? (
                        <CircularProgress
                          size="1em"
                          sx={{ mt: 1.5, ml: 0.7 }}
                        />
                      ) : (
                        <Tooltip title="Reload">
                          <RefreshOutlinedIcon
                            color="primary"
                            fontSize="medium"
                            onClick={() => this.getAllDepartmentGroup(true)}
                            sx={{
                              cursor: "pointer",
                              mt: 1,
                            }}
                          />
                        </Tooltip>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  {this.state.newDepartmentGroup && (
                    <tr>
                      <td>
                        <Form.Label>MAX DAYS PACKET ALLOWED
                          <sup style={{ color: "red" }}>*</sup>
                        </Form.Label>
                      </td>
                      <td>
                        <TextField
                          margin="normal"
                          fullWidth
                          size="small"
                          type="number"
                          label="Max Days Packet Allowed"
                          placeholder="Enter Days"
                          value={this.state.newmaxdayspacketallowed || ""}
                          onChange={(e) => {
                            let inputValue = e.target.value;
                            let maxAllowed = this.state.departmentMaxDaysPacketAllowed[this.state.newDepartmentGroup.value] || 0;

                            this.setState({
                              newmaxdayspacketallowed: inputValue,
                              validateDepartmentMaxDaysMsg:
                                Utility.CheckIsPresent(inputValue) && parseInt(inputValue) > maxAllowed
                                  ? `Max allowed days cannot be greater than ${maxAllowed}`
                                  : "",
                            });
                          }}
                          error={!!this.state.validateDepartmentMaxDaysMsg}
                        />
                        {this.state.validateDepartmentMaxDaysMsg && (
                          <FormHelperText style={{ color: "red", marginLeft: 0 }}>
                            {this.state.validateDepartmentMaxDaysMsg}
                          </FormHelperText>
                        )}
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Department Head</Form.Label>
                    </td>
                    <td style={{ width: "100%" }}>
                      <Box maxHeight={350}>
                        <Select menuPlacement="auto"
                          blurInputOnSelect={false}
                          isMulti
                          closeMenuOnSelect={false}
                          value={this.state.newDepartmentHead}
                          isSearchable={true}
                          name="Department"
                          styles={Constants.Styles}
                          menuPortalTarget={document.body}
                          options={this.state.departmentHeadOptions}
                          onChange={(selectedOption) => {
                            this.handleDepartmentHead(selectedOption)
                          }
                          }
                        />
                      </Box>
                    </td>
                    <td>
                      <Tooltip title="View More Data">
                        <span style={{ cursor: "pointer", marginLeft: "8px" }}>
                          <OpenInNewIcon
                            style={{ fontSize: "20px", marginBottom: "3px" }}
                            onClick={() => {
                              this.setState({ showUserDetailModal: true, userDetailContext: "H" });
                            }}
                            color="action"
                          />
                        </span>
                      </Tooltip>
                    </td>
                    <td>
                      {this.state.showDepartmentHeadLoadSpinner ? (
                        <CircularProgress
                          size="1em"
                          sx={{ mt: 1.5, ml: 0.7 }}
                        />
                      ) : (
                        <Tooltip title="Reload">
                          <RefreshOutlinedIcon
                            color="primary"
                            fontSize="medium"
                            onClick={() => this.getAllDepartmentHead(true)}
                            sx={{
                              cursor: "pointer",
                              mt: "0px",
                            }}
                          />
                        </Tooltip>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Department Users</Form.Label>
                    </td>
                    <td style={{ width: "100%", maxHeight: "300px" }}>
                      <Select menuPlacement="auto"
                        blurInputOnSelect={false}
                        isMulti
                        closeMenuOnSelect={false}
                        value={this.state.newDepartmentUsers}
                        isSearchable={true}
                        name="Department"
                        styles={Constants.Styles}
                        menuPortalTarget={document.body}
                        options={this.state.departmentUsersOptions}
                        onChange={(selectedOption) =>
                          this.handleDepartmentUsers(selectedOption)
                        }
                      />
                    </td>
                    <td>
                      <Tooltip title="View More Data">
                        <span style={{ cursor: "pointer", marginLeft: "8px" }}>
                          <OpenInNewIcon
                            style={{ fontSize: "20px", marginBottom: "3px" }}
                            onClick={() => {
                              this.setState({ showUserDetailModal: true, userDetailContext: "U" });
                            }}
                            color="action"
                          />
                        </span>
                      </Tooltip>
                    </td>
                    <td>
                      {this.state.showDepartmentUsersLoadSpinner ? (
                        <CircularProgress
                          size="1em"
                          sx={{ mt: 1.5, ml: 0.7 }}
                        />
                      ) : (
                        <Tooltip title="Reload">
                          <RefreshOutlinedIcon
                            color="primary"
                            fontSize="medium"
                            onClick={() => this.getAllDepartmentUsers(true)}
                            sx={{
                              cursor: "pointer",
                              mt: "0px",
                            }}
                          />
                        </Tooltip>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </center>
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
